import { buildSchema, buildProperty } from "@camberi/firecms";

export const oneToOneProductSchema = buildSchema({
    name: "Product",
    properties: {
        name: {
            title: "Product Name",
            dataType: "string",
            validation: { required: true },
        },
        active: {
            title: "Status",
            dataType: "boolean",
            validation: { required: true },
        },
        isOneToOne: {
            title: "Is One To One",
            dataType: "boolean",
            disabled: true,
        },
        
        // prices: buildProperty({
        //     title: "Price",
        //     dataType: "reference",
        //     path: "media",
        //     previewProperties: ["mediaUrl"],
        // }),
        
    },
    defaultValues: {
        status: false,
        order: 0,
        isOneToOne: true
    }
});

export const oneToOnePriceSchema = buildSchema({
    name: "Price",
    properties: {
        name: {
            title: "Name",
            dataType: "string",
            validation: { required: true },
        },
        priceAmount: {
            title: "Amount",
            dataType: "number",
            validation: { required: true },
            
        },
        content: buildProperty({
            title: "Content",
            description: "Content",
            validation: { required: true },
            dataType: "array",
            of: {
                dataType: "string",
                config: {
                    // previewAsTag: true
                }
            }
        }),
        showDefault: buildProperty({
            title: "Show Default",
            dataType: "boolean"
        }),
        product: {
            title: "Product",
            dataType: "string",
            disabled: true,
            // validation: { required: true },
        },
        currency: {
            title: "Currency",
            dataType: "string",
            disabled: true,
            // validation: { required: true },
        },
        unit_amount: {
            title: "Amount",
            dataType: "number",
            disabled: true,
            // validation: { required: true },
            
        },
        number_of_sessions: {
            title: "Number Of Sessions",
            dataType: "number",
            // validation: { required: true },
        },
        active: buildProperty({
            title: "Status",
            dataType: "boolean",
            disabled: true,
            // validation: { required: true },
        }),
       
        stripe_metadata_nickName: {
            title: "Stripe MetaData Name",
            dataType: "string",
            disabled: true,
            // validation: { required: true },
        },
        
    },
    defaultValues: {
        active: true,
        order: 0
    }
});
